import { Modal, Table, Button } from "antd";
import React from "react";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { ENDPOINT } from "../../../constants";

const ViewPayments = ({ open, close, data, module }) => {

  // Ensure data is an array and sort by date/time ascending (oldest first, latest last)
  const selectedPayments = (Array.isArray(data) ? [...data] : []).sort((a, b) => {
    const dateA = new Date(a.dateOfPayment || a.createdAt || 0).getTime();
    const dateB = new Date(b.dateOfPayment || b.createdAt || 0).getTime();
    return dateA - dateB;
  });

  // Get the first payment's moduleId for group download
  const moduleId = selectedPayments.length > 0 ? selectedPayments[0].moduleId : null;

  // Check if there is at least one successful payment to allow receipt downloading
  const hasSuccessfulPayment = selectedPayments.some((p) => p.status === "SUCCESS");

  return (
    <Modal
      title="Receipt Details"
      visible={open}
      onCancel={close}
      footer={null}
      width={1050}
      destroyOnClose
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 12,
        }}
      >
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          href={moduleId && hasSuccessfulPayment ? `${ENDPOINT}api/payment/${module}/receipt/${moduleId}?group=true` : "#"}
          target="_blank"
          rel="noopener noreferrer"
          disabled={!moduleId || !hasSuccessfulPayment}
        >
          Download All Receipts
        </Button>
      </div>
      <Table
        dataSource={selectedPayments}
        rowKey={(record) => record.id}
        pagination={false}
        scroll={{ x: "max-content" }}
        columns={[
          {
            title: <span style={{ whiteSpace: "nowrap" }}>S.No</span>,
            key: "serial",
            width: 70,
            align: "center",
            render: (text, record, index) => index + 1,
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Method</span>,
            key: "method",
            width: 130,
            render: (record) => {
              const method = record.method || record.paymentMode;
              return <span style={{ whiteSpace: "nowrap" }}>{method ? method.toUpperCase() : "-"}</span>;
            },
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Account</span>,
            key: "bankName",
            width: 140,
            render: (record) => {
              const bank = record.bank || record.BankDetails;
              const bankBranch = bank?.branchName || (bank?.Branch && bank?.Branch.length > 0 ? bank?.Branch[0]?.name : null);
              let val = "-";
              if (bankBranch) {
                val = bankBranch.toUpperCase();
              } else if (bank) {
                val = bank.accountNumber || bank.accountName || bank.name || "-";
              } else {
                const financierName = record.supplier?.name || record.branch?.name;
                val = financierName ? financierName.toUpperCase() : "-";
              }
              return <span style={{ whiteSpace: "nowrap" }}>{val}</span>;
            },
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Collected Amount (₹)</span>,
            dataIndex: "collectedAmount",
            key: "collectedAmount",
            width: 150,
            render: (amt) => (
              <span style={{ whiteSpace: "nowrap" }}>
                {amt ? Number(amt).toLocaleString("en-IN") : "0"}
              </span>
            ),
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Status</span>,
            dataIndex: "status",
            key: "status",
            width: 90,
            render: (status) => (
              <span
                style={{
                  color: status === "SUCCESS" ? "green" : "red",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                }}
              >
                {status}
              </span>
            ),
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Date</span>,
            key: "paymentDate",
            width: 160,
            render: (_, record) => {
              const dateVal = record.dateOfPayment || record.createdAt;
              const dateStr = dateVal ? moment(dateVal).format("DD/MM/YYYY, h:mm A") : "-";
              return <span style={{ whiteSpace: "nowrap" }}>{dateStr}</span>;
            },
          },
          {
            title: <span style={{ whiteSpace: "nowrap" }}>Collected By</span>,
            key: "collectedBy",
            width: 160,
            render: (_, record) => {
              const empName =
                record.collectedBy?.employeeName ||
                record.EmployeeProfile?.employeeName ||
                record.employee?.profile?.employeeName ||
                record.employee?.employeeName ||
                (typeof record.collectedBy === "string" ? record.collectedBy : null);
              if (!empName) return "-";
              const formatted = empName
                .toLowerCase()
                .split(" ")
                .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
                .join(" ");
              return <span style={{ whiteSpace: "nowrap" }}>{formatted}</span>;
            },
          },
          {
            title: "",
            key: "download",
            align: "center",
            width: 50,
            render: (record) => (
              record.status === "SUCCESS" ? (
                <a
                  href={`${ENDPOINT}api/payment/${module}/receipt/${record.id}?group=false`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download Payment PDF"
                >
                  <DownloadOutlined
                    style={{ fontSize: 18, color: "#1890ff" }}
                  />
                </a>
              ) : null
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default ViewPayments;
